export const GS_EIP712_TYPES = {
    GenericSwapData: [
        {
            name: 'maker',
            type: 'address',
        },
        {
            name: 'takerToken',
            type: 'address',
        },
        {
            name: 'takerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'makerToken',
            type: 'address',
        },
        {
            name: 'makerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'minMakerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'expiry',
            type: 'uint256',
        },
        {
            name: 'salt',
            type: 'uint256',
        },
        {
            name: 'recipient',
            type: 'address',
        },
        {
            name: 'strategyData',
            type: 'bytes',
        },
    ],
};
//# sourceMappingURL=gsEIP712Types.js.map